import { cn } from '@/lib/utils';
import type { ProjectSubmissionStatus } from '@/types';

const STATUS_CONFIG = {
  submitted: {
    label: 'ACEPTADA',
    pillClass: 'bg-primary text-background',
  },
  requirement_missing: {
    label: 'RECHAZADA',
    pillClass: 'bg-destructive text-destructive-foreground',
  },
  unsubmitted: {
    label: 'SIN ENTREGA',
    pillClass: 'bg-muted text-muted-foreground',
  },
} as const;

export function SubmissionStatusPill({
  status,
  className,
}: {
  status: ProjectSubmissionStatus;
  className?: string;
}) {
  const config = STATUS_CONFIG[status];

  return (
    <span
      className={cn(
        'inline-block px-3 py-1 font-bold text-xs',
        config.pillClass,
        className,
      )}
    >
      {config.label}
    </span>
  );
}
